export default "__VITE_ASSET__b832d9a1__"